import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { SelectAEPSOperator as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { TwoFactorAuthentication as MERCHANT_AUTHENTICATION } from 'Components/Api/FingpayAEPSAPI';
import {
    SelectBank as BANK_SELECT,
    CashWithdrawal as CASH_WITHDRAWAL,
    BalanceEnquiry as BALANCE_ENQUIRY,
    MiniStatement as MINI_STATEMENT,
    AadharPay as AADHAR_PAY,
    CheckUserAgentID as CHECKUSERAGENTID
} from 'Components/Api/FingpayAEPSAPI';
import { DailyAuthenticationSelect as SELECT_LAST_2FA } from 'Components/Api/DailyAuthonticationApi';
import Box from '@material-ui/core/Box';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    ListItemIcon,
    Button
} from '@material-ui/core';
import { AEPS_CODE } from 'Components/Helper/Messages';
import {
    AEPS_BALANCEENQUIRY,
    AEPS_MINISTATEMENT,
    AEPS_AADHARPAY,
    AEPS_CASHWITHDRAW
} from 'Components/Helper/OperatorCode';
import { GetServiceCharge as SELECT_CHARGE } from 'Components/Api/ServiceChargeDeductionAPI';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID,
    AEPS_Onboarding,
    AEPS_OPERATOR_ID,
    MESSAGE_CLOSE_AFTER
} from 'Components/Helper/Messages';
import usePosition from 'Components/Posistion';
import { BalanceContext } from 'Components/BalanceContext';
import { useHistory } from 'react-router';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import HOCLoader from 'Components/Loader/HOCLoader';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { Event } from 'ReactGa';
import InputLabel from 'Components/Inputes/InputLabel';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { FINGPAY } from 'Components/Helper/AEPSProviderName';
const CustomContainer = HOCLoader(Container);

export const FingpayAEPS = () => {
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const [RefreshRandom, setRefreshRandom] = useState(0);
    const history = useHistory();
    let serviceCode = AEPS_CODE;
    const formRef = useRef();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const { latitude, longitude } = usePosition();
    const classes = commonStyle();

    const [Operator, setOperator] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [shouldDisplayAmount, setShouldDisplayAmount] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [InWords, setInWords] = useState('');
    const [bankList, setBankList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');
    const [ServiceCharge, setServiceCharge] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [LastTwoFA, setLastTwoFA] = useState('');
    const [IsProceedBtn, setIsProceedBtn] = useState(true);
    const [IsMerchantBtn, setIsMerchantBtn] = useState(false);
    const [IsActiveMerchantverify, setIsActiveMerchantverify] = useState(false);
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [isVerifyAlertOpen, setVerifyAlertOpen] = useState(false);
    const RetailerMobile = localStorage.getItem('MobileNumber');

    const [bankDefault, setBankDefault] = useState({
        IIN: '',
        BankName: 'Select Bank'
    });

    const [formObj, setFormObj] = useState({
        ServiceID: serviceCode,
        IIN: '',
        BankName: '',
        Charge: 0,
        OperatorID: '',
        AadhaarNumber: '',
        ConsumerNumber: '',
        Amount: '',
        InWords: '',
        OperatorName: '',
        OperatorImagePath: '',
        Pin: '',
        IsPin: isPin,
        Bank: bankDefault
    });
    const reset = () => {
        setInWords('');
        setBankDefault({
            IIN: '',
            BankName: 'Select Bank'
        });
        setFormObj({
            ServiceID: serviceCode,
            OperatorID: '',
            AadhaarNumber: '',
            ConsumerNumber: '',
            Amount: '',
            InWords: '',
            OperatorName: '',
            OperatorImagePath: '',
            Pin: '',
            IsPin: isPin,
            Bank: bankDefault
        });
    };

    const validationSchema = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),
        AadhaarNumber: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + 'Aadhaar Number'),

        ConsumerNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),

        Pin: Yup.number().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.number().required('Please enter pin')
        })
    });

    const selectBank = async () => {
        setLoadingOpen(true);
        const response = await BANK_SELECT();
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };
    const getCharge = async () => {
        var requestObj = {
            ServiceID: AEPS_Onboarding
        };
        var request = JSON.stringify(requestObj);
        const response = await SELECT_CHARGE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            return;
        }
        var data = JSON.parse(response.data);

        setServiceCharge(data);
    };

    const selectlast2fa = async (values) => {
        setLoadingOpen(true);
        var request = {
            ProviderName: FINGPAY
        };
        var requestObj = JSON.stringify(request);
        const response = await SELECT_LAST_2FA(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        var data = JSON.parse(response.data);
        setLastTwoFA(data.DOC);
        setIsActiveMerchantverify(data.IsMerchantVerify);
        if (data.Is2FA) history.push('/FPAuthentication');
    };

    const submitHandle = async (values, { resetForm }) => {
        if (values.IsMerchantVerify) {
            setVerifyAlertOpen(true);
            setConfirmAlertRequest(values);
            return;
        } else {
            let op = Operator.filter((o) => o.OperatorID === values.OperatorID);

            values.OperatorName = op[0].OperatorName;
            values.OperatorImagePath = op[0].Path;
            values.Charge = ServiceCharge;

            setIsAlertOpen(true);
            setConfirmAlertRequest(values);
        }
    };

    const GetOperatorName = (OperatorID) => {
        var opName = '';
        opName = Operator.find(function (values) {
            if (values.OperatorID === OperatorID) return values.OperatorName;
            return '';
        });

        return opName.OperatorName;
    };
    const MerchantVerify = async (values) => {
        setIsError(false);
        setResponseMessage('');
        setLoadingOpen(true);
        const { status, xmldata } = await GetFingerPrint('');
        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        var request = {
            FingerPrint: fingerPrintXML,
            MobileNumber: RetailerMobile,
            OperatorID: AEPS_OPERATOR_ID,
            Latitude: latitude,
            Longitude: longitude
        };
        var requestObj = JSON.stringify(request);
        var response = await MERCHANT_AUTHENTICATION(requestObj);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        var data = JSON.parse(response.data);

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data.Message);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }
        setIsMerchantBtn(false);
        setIsProceedBtn(true);
        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);
    };

    const Proceed = async (values) => {
        setLoadingOpen(true);
        setResponseMessage('');
        setIsError(false);

        const { status, xmldata } = await GetFingerPrint('');

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        Event('AEPS', 'AEPS', await GetOperatorName(values.OperatorID));
        let response = '';

        if (values.OperatorID === AEPS_BALANCEENQUIRY) {
            var requestObj = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.BankName,
                FingerPrint: fingerPrintXML,
                Latitude: latitude,
                Longitude: longitude
            };
            var request = JSON.stringify(requestObj);

            response = await BALANCE_ENQUIRY(request);
        } else if (values.OperatorID === AEPS_MINISTATEMENT) {
            var requestObjMS = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.BankName,
                FingerPrint: fingerPrintXML,
                Latitude: latitude,
                Longitude: longitude
            };
            var requestMS = JSON.stringify(requestObjMS);

            response = await MINI_STATEMENT(requestMS);
        } else if (values.OperatorID === AEPS_AADHARPAY) {
            var requestObjAadharPay = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.BankName,
                FingerPrint: fingerPrintXML,
                Amount: values.Amount,
                Latitude: latitude,
                Longitude: longitude
            };
            var requestAadharPay = JSON.stringify(requestObjAadharPay);

            response = await AADHAR_PAY(requestAadharPay);
        } else {
            var requestObjCW = {
                AadhaarNumber: values.AadhaarNumber,
                ConsumerNumber: values.ConsumerNumber,
                IIN: values.IIN,
                BankName: values.BankName,
                FingerPrint: fingerPrintXML,
                Amount: values.Amount,
                Latitude: latitude,
                Longitude: longitude
            };
            var requestCW = JSON.stringify(requestObjCW);

            response = await CASH_WITHDRAWAL(requestCW);
        }

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        await DashboardBalanceUpdate();

        setRefreshRandom(Math.random(0));

        var data = JSON.parse(response.data);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            setIsOpen(true);
            return;
        }
        setSeverity('success');
        setResponseMessage(
            data.Message +
            ', Available Balance:' +
            data.AvailableBalance +
            ' , BankRRN:' +
            data.BankRRN
        );
        setStatus(data.Status);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);

        setIsError(true);

        if (data.Status === 'FAILURE') setSeverity('error');
        //if (formRef.current) formRef.current.resetForm();

        reset();
    };

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;
        setInWords(NumberToWord(value));
        setFieldValue('InWords', NumberToWord(value));
    };

    const handleOperatorChange = (name, value, setFieldValue) => {
        setFieldValue(name, value);
        setIsProceedBtn(true);
        setIsMerchantBtn(false);
        if (value === AEPS_BALANCEENQUIRY) {
            setShouldDisplayAmount(false);

            return;
        }
        if (value === AEPS_MINISTATEMENT) {
            setShouldDisplayAmount(false);
            return;
        }

        if (value === AEPS_CASHWITHDRAW && IsActiveMerchantverify === true) {
            setIsProceedBtn(false);
            setIsMerchantBtn(true);
        }

        setShouldDisplayAmount(true);
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };
    const CheckFingpayAgentID = async () => {
        setResponseMessage('');
        const response = await CHECKUSERAGENTID();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            const data = JSON.parse(response.data);
            setResponseMessage(data.Message);

            if (data.Message === 'User not onboarded' || data.Message === 'Bank Data Pending') {
                history.push('/FPUserOnbording');
            } else if (data.Message === 'EKYC Pending') {
                history.push('/FPSendOTP');
            } else if (data.Message === 'Already Onboarded User' || data.Message === 'Need2FA' || data.Need2FA === 'Yes') {
                history.push('/FPAuthentication');
            }
            return;
        }
        selectlast2fa();
    };

    useEffect(() => {
        getCharge();
        fetchConsumerNumberFontSize();
        selectBank();
        CheckFingpayAgentID();
        selectOperator(serviceCode);
    }, [serviceCode, latitude]);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Grid container>
                                            <Grid xs={12} sm={12} md={4} lg={4}>
                                                <h2
                                                    className={
                                                        classes.PaperHead_h2
                                                    }
                                                >
                                                    AEPS :: Lat. {latitude}, Long. {longitude}
                                                </h2>
                                            </Grid>
                                            <Grid
                                                xs={12}
                                                sm={12}
                                                md={8}
                                                lg={8}
                                                className={classes.twofa}
                                            >
                                                <Box>
                                                    <span
                                                        className={
                                                            classes.lasttwofa
                                                        }
                                                    >
                                                        <span
                                                            className={
                                                                classes.labellasttwofa
                                                            }
                                                        >
                                                            Last 2FA :
                                                        </span>
                                                        {LastTwoFA}
                                                    </span>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={() => {
                                                            history.push(
                                                                '/FPAuthentication'
                                                            );
                                                        }}
                                                    >
                                                        2FA
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        SubFieldName="BankName"
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        onSearchCallback={(
                                                            text
                                                        ) => {
                                                            //callSearch(text);
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'IIN',
                                                                value.IIN
                                                            );

                                                            setFieldValue(
                                                                'BankName',
                                                                value.BankName
                                                            );

                                                            setBankDefault({
                                                                IIN: value.IIN,
                                                                BankName:
                                                                    value.BankName
                                                            });

                                                            // formRef.current.values.IIN = value.IIN;
                                                            // formRef.current.values.BankName = value.BankName;
                                                        }}
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.BankName}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.BankName ===
                                                            value.BankName
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Aadhaar Number"
                                                        name="AadhaarNumber"
                                                        icon="mobile"
                                                        placeholder="Aadhaar Number"
                                                        title="Aadhaar Number"
                                                        length="12"
                                                        //typed_length={1}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Consumer Number"
                                                        name="ConsumerNumber"
                                                        icon="mobile"
                                                        placeholder="Consumer Number"
                                                        title="Consumer Number"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialSelect
                                                        label="Select Type"
                                                        name="OperatorID"
                                                        title="Type"
                                                        size="small"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            handleOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    >
                                                        {Operator.map(
                                                            (item) => (
                                                                <MenuItem
                                                                    key={
                                                                        item.OperatorID
                                                                    }
                                                                    value={
                                                                        item.OperatorID
                                                                    }
                                                                >
                                                                    <ListItemIcon
                                                                        style={{
                                                                            verticalAlign:
                                                                                'middle'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                item.Path
                                                                            }
                                                                            height={
                                                                                30
                                                                            }
                                                                            width={
                                                                                30
                                                                            }
                                                                            alt={
                                                                                item.OperatorName
                                                                            }
                                                                        />
                                                                    </ListItemIcon>
                                                                    {
                                                                        item.OperatorName
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </MaterialSelect>
                                                </Grid>
                                                {shouldDisplayAmount ? (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                    >
                                                        <MaterialCurrency
                                                            font_size={
                                                                consumerNumberFontSize
                                                            }
                                                            name="Amount"
                                                            label="Amount"
                                                            placeholder="Amount"
                                                            autoComplete="new-password"
                                                            size="normal"
                                                            max={10000}
                                                            title="Amount"
                                                            onCustomCallback={(
                                                                value
                                                            ) => {
                                                                OnChange(
                                                                    value,
                                                                    setFieldValue
                                                                );
                                                            }}
                                                        />
                                                        <InputLabel
                                                            color="green"
                                                            value={InWords}
                                                        />
                                                    </Grid>
                                                ) : null}
                                                {isPin === 'true' ? (
                                                    <Grid item xs>
                                                        <MaterialNumberField
                                                            label="Pin"
                                                            type="password"
                                                            name="Pin"
                                                            placeholder="Pin"
                                                            title="Pin"
                                                            length={4}
                                                        />
                                                    </Grid>
                                                ) : null}
                                            </Grid>
                                        </Paper>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            spacing={2}
                                            container
                                            className={classes.footerGrid}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                <SecondaryButton
                                                    disabled={loadingOpen}
                                                    endIcon={<ResetIcon />}
                                                    title="Reset"
                                                    onClick={() => {
                                                        reset();
                                                    }}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                            >
                                                {IsProceedBtn && (
                                                    <PrimaryButton
                                                        title="Proceed"
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsProceed',
                                                                true
                                                            );
                                                            setFieldValue(
                                                                'IsMerchantVerify',
                                                                false
                                                            );
                                                        }}
                                                        disabled={loadingOpen}
                                                        endIcon={
                                                            <RechargeIcon />
                                                        }
                                                    />
                                                )}
                                                {IsMerchantBtn && (
                                                    <PrimaryButton
                                                        title="Merchant Verify"
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsProceed',
                                                                false
                                                            );
                                                            setFieldValue(
                                                                'IsMerchantVerify',
                                                                true
                                                            );
                                                        }}
                                                        disabled={loadingOpen}
                                                        endIcon={
                                                            <RechargeIcon />
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Box marginTop={6}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <label>
                                                    <h3
                                                        className={
                                                            classes.Provider_Format
                                                        }
                                                    >
                                                        <strong>NOTE</strong>:
                                                        <span
                                                            className={
                                                                classes.normalTextColor
                                                            }
                                                        >
                                                            "Enhance AEPS &
                                                            AdhaarPay security:
                                                            Daily 2FA
                                                            authentication is
                                                            mandatory."
                                                        </span>
                                                    </h3>
                                                </label>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <Last10RechargeReport
                                    ServiceID={serviceCode}
                                    refreshRandom={RefreshRandom}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>
            {isVerifyAlertOpen && (
                <ConfirmAlert
                    isOpen={isVerifyAlertOpen}
                    title="Merchant Authentication"
                    message="Are you sure to do merchant authentication?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setVerifyAlertOpen(false);
                        MerchantVerify(request);
                    }}
                    negativeButtonClick={() => {
                        setVerifyAlertOpen(false);
                    }}
                />
            )}

            {isAlertOpen && (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="AEPS"
                    message="Are you sure to do transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Proceed(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            )}
            {isResponseAlertOpen && (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={AEPS_CODE}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                        setIsOpen(true);
                    }}
                />
            )}
            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                        setIsOpen(true);
                    }}
                />
            )}
        </CustomContainer>
    );
};
